import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import '../firstaid.css';
import ChatBubble from '../../../components/ChatBubble/ChatBubble';
import FIRSTAIDIMAGES from '../../../assets/designSystem/icons/firstAid';
import SIGNSANDSYMPTOMSIMAGES from '../../../assets/designSystem/icons/signsAndSymptoms';

export default function ProcedureSection({ question, options = [], stepcolors, symptoms }) {
  const { t } = useTranslation();

  const STEPS = useMemo(() => {
    return options.map((option, index) => ({
      image: symptoms ? SIGNSANDSYMPTOMSIMAGES[option.icon] : FIRSTAIDIMAGES[option.icon],
      label: t(option.label),
      color: stepcolors[index] ?? '#51A0CD',
      id: `${option.label}-${index}`,
    }));
  });

  return (
    <div className="definition__container">
      <ChatBubble text={t(question)} />
      <div className="procedure__container">
        {STEPS.map((step) => (
          <Card key={step.label} {...step} />
        ))}
      </div>
    </div>
  );
}

function Card({ image, label, color }) {
  return (
    <div className="card__container" style={{ backgroundColor: color }}>
      <img alt="img" src={image} className="card__banner" />
      <p className="card__label">{label}</p>
    </div>
  );
}
